import React, { useEffect, useState, useRef } from 'react';
import ProductTag from '../ProductTag';
import { AdvancedImage } from '@cloudinary/react';
import { Cloudinary } from "@cloudinary/url-gen";
import { format } from '@cloudinary/url-gen/actions/delivery';
import { addUpdateCart, addWishlist, checkProductInCart, checkProductInWishlist, removeWishlist } from '@common/utils/cart';
import { Link } from 'react-router-dom';
import CustomCounterWidget from '@common/components/CustomCounterWidget';
import { useProductStatus } from 'hooks/useProductStatus';
import { useProductActions } from 'hooks/useProductActions';
import { isUserLoggedIn } from '@common/utils/auth/authService';
import { useDispatch } from 'react-redux';
import { openSignInModal } from 'store/slices/authSlice';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Autoplay, Pagination } from 'swiper/modules';

function ProductTile({ thumbnailImages, imageUrl, tagTitle, handleAction, productTitle, priceValue, strikePriceValue, colorVariants, productId = "", productSlug = "", showAddToCart = true, productQty = 0, stock = 0, setCartData, isWishlistActive = false, variant, isOutOfStock = false }) {
    const dispatch = useDispatch();
    const extraColorsCount = colorVariants?.filter(item => item.id !== productId)?.length - 2;
    // const extraColorsCount = colorVariants?.length - 2;

    const { getCartQuantity, getProductInStock, isInWishlist, isInCart, isStockLimitAvailable } = useProductStatus();
    const { toggleWishlist, addToCart, updateCartQuantity } = useProductActions();
    const [wishlistActive, setWishlistActive] = useState(isInWishlist(productId));
    useEffect(() => {
        setWishlistActive(isInWishlist(productId));
    }, [isInWishlist(productId)]);

    const itemProductQty = getCartQuantity(productId);
    const itemProductStock = getProductInStock(productId);

    useEffect(() => {
        setWishlistActive(checkProductInWishlist(productId));
    }, [productId]);

    const wishListActiveHandleChange = async (e, productId, type) => {
        e.preventDefault();
        if (isUserLoggedIn()) {
            toggleWishlist(productId, type);
        } else {
            dispatch(openSignInModal());
        }
        // if (type === 'remove') {
        //     await removeWishlist(productId); // Perform the remove action
        //     setWishlistActive(false); // Update the state to reflect the removal
        // } else {
        //     await addWishlist(productId); // Perform the add action
        //     setWishlistActive(true); // Update the state to reflect the addition
        // }
    };

    const cld = new Cloudinary({
        cloud: {
            cloudName: 'dci1aiukm'
        }
    });

    const myImage = cld.image(imageUrl).quality('auto').delivery(format('webp'));

    const formatINR = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
    };

    // cart qty state
    const [qty, setQty] = useState(itemProductQty);

    useEffect(() => {
        setQty(itemProductQty);
    }, [itemProductQty]);

    useEffect(() => {
        if (itemProductQty !== qty) {
            // updateCart(
            //     productId,
            //     qty,
            // )
            // console.log('update qty', qty);

            // addUpdateCart(productId, qty, 'update', setCartData);
            updateCartQuantity(productId, qty);
        }
    }, [qty]);

    // const updateCart = async (id, quantity) => {
    //     try {
    //         const cart = await addUpdateCart(id, quantity, 'update', setCartData); // Await the promise returned by getCart
    //         console.log('cart', cart);
    //         if (cart) {
    //             // setCartData(cart?.data);
    //         }
    //     } catch (error) {
    //         console.error('Error update cart:', error);
    //     }
    // };

    // console.log('getProductInStock(productId)', getProductInStock(productId));

    const swiperRef = useRef(null);
    const [hoverState, setHoverState] = useState(false);

    const tileHoverHandleEnterChange = () => {
            setHoverState(true);
            if (swiperRef.current?.autoplay) {
                swiperRef.current.autoplay.start();
            }
    }

    const tileHoverHandleOutChange = () => {
            setHoverState(false);
            if (swiperRef.current?.autoplay) {
                swiperRef.current.autoplay.stop();
            }
    }

    const autoPlayOptions = {
        delay: 1500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false, // avoid conflicting with manual hover handling
    };


    return (
        <Link 
            className='bs-product-tile' 
            to={`/product-description/${productSlug}`}
            onMouseEnter={tileHoverHandleEnterChange} 
            onMouseOut={tileHoverHandleOutChange}
            
        >
            <div className='bs-product-tile__head-wrap'>
                {tagTitle &&
                    <ProductTag
                        title={tagTitle}
                        classname="bs-product-tile__tag"
                    />
                }
                {/* {isUserLoggedIn() && */}
                <button
                    className='bs-product-tile__btn-like'
                    onClick={(e) => {
                        wishListActiveHandleChange(
                            e,
                            productId,
                            wishlistActive ? true : false
                        );
                    }}
                >
                    <span className={`icon  ${wishlistActive ? 'icon-like-fill' : 'icon-like'} bs-product-tile__icon-like`}></span>
                </button>
                {/* } */}
                {(!isInCart(productId) && isOutOfStock) ? (
                    <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse bs-product-tile__action' onClick={(e) => { e.preventDefault() }}>Out of stock</button>
                ) : (<>
                    <button
                        className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse bs-product-tile__action'
                        onClick={(e) => {
                            e.preventDefault();
                            const count = getCartQuantity(productId) + 1;
                            const productStock = isInCart(productId) ? getProductInStock(productId) : stock;
                            if (isStockLimitAvailable(productStock, count)) {
                                addToCart(productId, count)
                            } else {
                                toast.error(`Only ${productStock} available in stock`);
                            }
                        }}
                    >
                        Add to cart
                    </button>
                </>)}

                {/* // (!isInCart(productId) && showAddToCart) ? 
            //     <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse bs-product-tile__action' onClick={(e) => {e.preventDefault(); addToCart(productId, 1)}}>Add to cart</button>
            // : (isInCart(productId) && showAddToCart) ? (<>
            //     <div className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse bs-product-tile__action'>
            //         <CustomCounterWidget 
            //             count={qty} 
            //             setCount={setQty} 
            //             stock={itemProductStock}
            //         />
            //     </div>
            // </>) : null} */}

                <div className='bs-product-tile__media-wrap' >
                   {thumbnailImages?.length > 1 ? (
                        <div className='bs-product-tile__media-ring-wrap'>
                            <Swiper
                                ref={swiperRef}
                                speed={1000}
                                spaceBetween={0}
                                centeredSlides={true}
                                autoplay={hoverState ? autoPlayOptions : false}
                                pagination={{
                                clickable: true,
                                }}
                                modules={[Autoplay, Pagination]}
                                className="mySwiper bs-product-tile__media-ring"
                                onSwiper={(swiper) => {
                                    swiperRef.current = swiper;
                                    swiper.autoplay.stop(); // Start paused
                                }}
                            >
                                {thumbnailImages.map((item, index) => {
                                    const slideImage = cld.image(item?.imageUrl).quality('auto').delivery(format('webp'));
                                    return (
                                        <SwiperSlide key={index}>
                                            <AdvancedImage cldImg={slideImage} loading="lazy" className='bs-product-tile__image' />
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                            <AdvancedImage cldImg={myImage} loading="lazy" className='bs-product-tile__image bs-product-tile__image-single' />
                        </div>
                    ) : (
                        <AdvancedImage cldImg={myImage} loading="lazy" className='bs-product-tile__image' />
                    )}
                </div>
            </div>
            <div className='bs-product-tile__info-wrap'>
                <h3 className='bs-product-tile__title'>{productTitle}</h3>
                <div className='bs-product-tile__more-info-wrap'>
                    <div className='bs-product-tile__price-wrap'>
                        <strong className='bs-product-tile__price'>{priceValue ? formatINR(priceValue) : formatINR(strikePriceValue)}</strong>
                        {priceValue && <strong className='bs-product-tile__price bs-product-tile__price--strike'>{strikePriceValue ? formatINR(strikePriceValue) : '₹0'}</strong>}
                    </div>
                    {colorVariants && <div className='bs-product-tile__color-list-wrap'>
                        {colorVariants.slice(0, 2).map((item, index) => (
                            // <span
                            //     className="bs-product-tile__color-item bs-product-tile__color-item--block"
                            //     style={{ backgroundColor: item.colorCode }}
                            //     key={item.id}
                            // ></span>
                            <img
                                className="bs-product-tile__color-item bs-product-tile__color-item--block"
                                src={cld.image(item.imageUrl).quality('auto').delivery(format('webp')).toURL()}
                                alt={index.slug}
                                key={index}
                            />
                        ))}
                        {extraColorsCount > 0 && (
                            <span className="bs-product-tile__color-item">+{extraColorsCount}</span>
                        )}
                    </div>}
                </div>
            </div>
        </Link>
    )
}

export default ProductTile